export interface WireDetails {
  beneficiaryBank: string;
  swiftCode: string;
  intermediaryBank?: string;
  iSwiftCode?: string;
  beneficiaryName: string;
  beneficiaryAddress: string;
  accountNo: number;
  iBan: string;
  referenceField: string;
  ABA?: string;
}
export function getWireDetails(currency: string) {
  const data: WireDetails = {
    beneficiaryBank: '',
    swiftCode: '',
    intermediaryBank: '',
    iSwiftCode: '',
    beneficiaryName: '',
    beneficiaryAddress: '',
    accountNo: -1,
    iBan: '',
    referenceField: '',
    ABA: ''
  };

  switch (currency.toLowerCase()) {
    case 'cad':
      data.beneficiaryBank = 'Citibank London';
      data.swiftCode = 'CITIGB2LXXX';
      data.intermediaryBank = 'Toronto Dominion Bank, Toronto';
      data.iSwiftCode = 'TDOMCATTTOR';
      data.beneficiaryName = 'DeltecBank and Trust Limited';
      data.beneficiaryAddress = 'Deltec House Lyford Cay, P.O. Box N-­‐3229, Nassau, Bahamas';
      data.accountNo = 11572458;
      data.iBan = 'GB89 CITI 1850 0811 5724 58';
      data.referenceField = 'a/c 1001252 LODE Global Corporation';
      break;
    case 'usd':
      data.beneficiaryBank = 'Citibank, NA, New York';
      data.swiftCode = 'CITIUS33XXX';
      data.ABA = '021000089';
      data.beneficiaryName = 'DeltecBank and Trust Limited';
      data.beneficiaryAddress = 'Deltec House Lyford Cay, P.O. Box N-­‐3229, Nassau, Bahamas';
      data.accountNo = 25602100;
      data.iBan = 'GB89 CITI 1850 0811 5724 58';
      data.referenceField = 'a/c 1001252 LODE Global Corporation';
      break;
    default:
      data.beneficiaryBank = 'Citibank London';
      data.swiftCode = 'CITIGB2LXXX';
      data.intermediaryBank = 'Citibank Europe PLC Dublin';
      data.iSwiftCode = 'CITIIE2XXXX';
      data.beneficiaryName = 'DeltecBank and Trust Limited';
      data.beneficiaryAddress = 'Deltec House Lyford Cay, P.O. Box N-­‐3229, Nassau, Bahamas';
      data.accountNo = 11572431;
      data.iBan = 'GB42 CITI 1850 0811 5724 31';
      data.referenceField = 'LODE Global Corporation–1001252';
      break;
  }
  return data;
}
